import React, { useState, useEffect, useContext, useRef } from 'react';
import styles from './Residents.module.css';

import LayoutDefault from '../../Components/LayoutDefault/LayoutDefault';
import Panel from '../../Components/Panel/Panel';
import PanelListDefault from '../../Components/PanelListDefault/PanelListDefault';
import RemoveIdsNotFound from '../../Components/RemoveIdsNotFound/RemoveIdsNotFound';
import ExecuteAxios from '../../Components/ExecuteAxios/ExecuteAxios';
import ResetVariables from '../../Components/ResetVariables/ResetVariables';
import ApplyAttributes from '../../Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from '../../Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import { AuthContext } from '../../Contexts/auth';
import UnitsResident from './UnitResidence/UnitsResident';
import LoadingIndicator from '../../Components/LoadingIndicator/LoadingIndicator';
import InputField from '../../Components/Input/InputField';
import OptionsDataByAttributePath from '../../Components/Options/optionsData/OptionsDataByAttributePath';
import SearchableComboBox from '../../Components/SearchableComboBox/SearchableComboBox';
import { FaList, FaEdit } from 'react-icons/fa';

function Residents() {
    const { clientSelected, clientSelectedHandled, setClientSelectedHandled } = useContext(AuthContext);
    const [id, setId] = useState(null)
    const [consumerUnitId, setConsumerUnitId] = useState(null);
    const [name, setName] = useState(null);
    const [phone, setPhone] = useState(null);
    const [email, setEmail] = useState(null);
    const [isPending, setIsPending] = useState(null);
    const [isActive, setIsActive] = useState('S')

    const [residentsRecords, setResidentsRecords] = useState(null)
    const [residentsRecordDetail, setResidentsRecordDetail] = useState(null)
    const [selectedsResidents, setSelectsResidents] = useState([])
    const [inserting, setInserting] = useState(false)
    const [updating, setUpdating] = useState(false)
    const [loadingPanel, setLoadingPanel] = useState(false)
    const [nameFilter, setNameFilter] = useState(null)
    const [consumerUnitIdFilter, setConsumerUnitIdFilter] = useState(null);
    const [descriptionLookup, setterDescriptionLookup] = useState('')
    const [unitsResidenceLookup, setUnitsResidenceLookup] = useState([])
    const unitsResidenceOptions = OptionsDataByAttributePath(unitsResidenceLookup, ['description'], null, true)
    const [activeTab, setActiveTab] = useState('list');
    const isMobile = window.innerWidth <= 786;

    const attributeList = [
        { name: "id", value: id, setter: setId },
        { name: "consumerUnitId", value: consumerUnitId, setter: setConsumerUnitId },
        { name: "name", value: name, setter: setName },
        { name: "phone", value: phone, setter: setPhone },
        { name: "email", value: email, setter: setEmail, width: '300px' },
        { name: "isPending", value: isPending, setter: setIsPending },
        {
            name: "isActive", value: isActive, setter: setIsActive, defaultValue: 'S',
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
    ];

    useEffect(() => {
        fetchEmployees();
    }, []);

    const fetchEmployees = async () => {
        const parameters = {
            clientId: clientSelected ?? 0
        };
        setUnitsResidenceLookup(await ExecuteAxios.api('get', '/consumer-unit/get-consumer-unit-lookup/', { params: parameters }));
    };

    const lookupUnitFilter = () => {
        return (
            <SearchableComboBox setAttribute={setConsumerUnitIdFilter}
                optionsData={unitsResidenceOptions}
                value={consumerUnitIdFilter}
                description={descriptionLookup}
                setterDescription={setterDescriptionLookup}
                styleInput={{ width: '150px' }}
                placeholder={'Unidade'}
                mainStyle={{ marginLeft: '10px' }}
            />
        )
    }

    const inputNameFilter = () => {
        return (
            <InputField
                setAttribute={setNameFilter}
                value={nameFilter}
                readOnly={false}
                disabled={false}
                placeholder={'Nome'}
                style={{ marginLeft: '10px', width: '150px', borderRadius: '4px' }}
            />
        )
    }

    const resetInsertUpdate = (async () => {
        setInserting(false)
        setUpdating(false)
    })

    const getRecordPanels = (async () => {
        setInserting(false)
        setUpdating(false)
        await getResidentsGrid()
    })

    useEffect(() => {
        resetInsertUpdate()
        getResidentsDetail(0)
        getRecordPanels()
    }, []);

    useEffect(() => {
        if (!clientSelected || !clientSelectedHandled) return
        setClientSelectedHandled(false)

        getRecordPanels()
    }, [clientSelectedHandled]);

    useEffect(() => {
        getRecordPanels()
    }, [consumerUnitIdFilter, nameFilter]);

    useEffect(() => {
        setDetailRecord(selectedsResidents)
    }, [selectedsResidents]);

    async function setDetailRecord(selectedsResidents) {
        if (selectedsResidents && selectedsResidents.length === 1) {
            setInserting(false)
            setUpdating(false)
            await getResidentsDetail(selectedsResidents[0])
        } else {
            setUpdating(false)
            ResetVariables.resetVariables(attributeList)
        }
    }

    async function getResidentsGrid() {
        const parameters = {
            clientId: clientSelected ?? 0,
            isActive: 'S',
            nameFilter: nameFilter,
            consumerUnitIdFilter: consumerUnitIdFilter
        }
        const residentsRecordsResponse = await ExecuteAxios.api('get', `/resident/get-resident-active-grid/`, { params: parameters });
        setResidentsRecords(residentsRecordsResponse);
        RemoveIdsNotFound.remove(residentsRecordsResponse, setSelectsResidents, selectedsResidents)
    }

    async function getResidentsDetail(selectedResident) {
        const parameters = {
            id: selectedResident
        }
        const residentsRecordsDetail = await ExecuteAxios.api('get', `/resident/get-resident-by-id-detail/`, { params: parameters });
        setResidentsRecordDetail(residentsRecordsDetail);
        if (residentsRecordsDetail) {
            ApplyAttributes.applyAttributes(residentsRecordsDetail, attributeList, inserting)
        }
    }

    async function putResidents() {
        try {
            setLoadingPanel(true)
            const parameters = {
                id: selectedsResidents[0],
                clientId: clientSelected ?? 0,
                consumerUnitId: consumerUnitId,
                name: name,
                phone: phone,
                email: email,
                isPending: isPending,
                isActive: isActive
            }
            return await ExecuteAxios.api('put', `/resident/`, parameters);
        } finally {
            setLoadingPanel(false)
        }
    }

    async function postResidents() {
        try {
            setLoadingPanel(true)
            const parameters = {
                clientId: clientSelected ?? 0,
                consumerUnitId: consumerUnitId,
                name: name,
                phone: phone,
                email: email,
                isPending: isPending,
                isActive: isActive
            }
            return await ExecuteAxios.api('post', `/resident/`, parameters);
        } finally {
            setLoadingPanel(false)
        }
    }

    const mainPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
    };

    return (
        <LayoutDefault>
            {(activeTab === 'list' || !isMobile) && (
                <Panel
                    className={'main-modal two left'}
                    style={mainPanelStyle}
                    titlePage={'Moradores'}
                    canViewCRUD={true}
                    recordsSelected={[]}
                    viewOnlyOneRecordCRUD={false}
                    resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                    dataListedAttributes={residentsRecords}
                    attributeList={attributeList}
                    onUpdateIdSelected={setSelectsResidents}
                    componentRightFilter={
                        <>
                            {inputNameFilter()}
                            {lookupUnitFilter()}
                        </>
                    }
                >
                    <LoadingIndicator loaded={residentsRecords && !loadingPanel}>
                        <PanelListDefault
                            onUpdateIdSelected={setSelectsResidents}
                            idsSelected={selectedsResidents}
                            data={residentsRecords}
                            attributeList={attributeList}
                            selectFirstRecord={true}
                            inserting={inserting}
                            updating={updating}
                        />
                    </LoadingIndicator>
                </Panel>
            )}

            {(activeTab === 'detail' || !isMobile) && (
                <Panel
                    className={'main-modal two right'}
                    style={mainPanelStyle}>
                    <Panel
                        style={{ ...mainPanelStyle, height: '50%' }}
                        titlePage={'Morador selecionado'}
                        setUpdating={setUpdating}
                        setInserting={setInserting}
                        inserting={inserting}
                        updating={updating}
                        enableEdit={true}
                        canEdit={selectedsResidents && selectedsResidents.length === 1}
                        putFunction={putResidents}
                        enableNewRecord={true}
                        canNewRecord={true}
                        postFunction={postResidents}
                        canViewCRUD={true}
                        recordsSelected={[]}
                        viewOnlyOneRecordCRUD={false}
                        resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                        dataListedAttributes={residentsRecords}
                        attributeList={attributeList}
                        onUpdateIdSelected={setSelectsResidents}
                        reloadFilter={
                            async () => {
                                await getResidentsGrid()
                            }
                        }
                        cancelFunction={
                            async () => {
                                await setDetailRecord(selectedsResidents)
                            }
                        }
                    >
                        <div style={{ height: 'calc(100% - 56px)' }}>
                            <LoadingIndicator loaded={residentsRecordDetail && !loadingPanel}>
                                <AutomaticallyListedAttributes
                                    list={residentsRecordDetail}
                                    attributeList={attributeList}
                                    readOnlyAttributes={!inserting && !updating}
                                />
                            </LoadingIndicator>
                        </div>
                    </Panel>
                    <UnitsResident residentId={selectedsResidents[0]} />
                </Panel>
            )}

            {/* Navegação inferior mobile */}
            {isMobile && (
                <div className={styles.bottomNav}>
                    <button
                        className={`${styles.navButton} ${activeTab === 'list' ? styles.active : ''}`}
                        onClick={() => setActiveTab('list')}
                    >
                        <FaList />
                        <span>Lista</span>
                    </button>
                    <button
                        className={`${styles.navButton} ${activeTab === 'detail' ? styles.active : ''}`}
                        onClick={() => setActiveTab('detail')}
                    >
                        <FaEdit />
                        <span>Detalhe</span>
                    </button>
                </div>
            )}
        </LayoutDefault >
    );
}

export default Residents;
